/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Catholic_Theology23Inputs */

const en__field__enum_additionalstudyinterests_study_catholic_theology23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Catholic_Theology23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catholic Theology`)
};

const de__field__enum_additionalstudyinterests_study_catholic_theology23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Catholic_Theology23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katholische Theologie`)
};

/**
* | output |
* | --- |
* | "Catholic Theology" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Catholic_Theology23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_catholic_theology23 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Catholic_Theology23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Catholic_Theology23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_catholic_theology23(inputs)
	return de__field__enum_additionalstudyinterests_study_catholic_theology23(inputs)
});
export { _field__enum_additionalstudyinterests_study_catholic_theology23 as "_field__enum_additionalStudyInterests_STUDY_CATHOLIC_THEOLOGY" }